import React from 'react';
import Helmet from 'react-helmet';
import Emo from './emoji';
import Icon from './icon';
import Cell from './cell';
import proj from '../static/projects.svg';

function Project ({ name, href, tech, year, desc }) {
  return (
    <div className='box padded project-box'>
      <h3><a href={href} target='_blank' rel="noopener noreferrer">{name}</a> <Icon name='external-link-alt' /></h3>
      <ul className='skills-list sm nm'>
      {
        tech.map(t => <li>{t}</li>)
      }
      </ul>
      <h4><Emo name='date' /> <span>{year}</span></h4>
      <div>{desc}</div>
    </div>
  );
}

export default function () {
  return (
    <>
      <Helmet>
        <title>Projects | gnsp.in</title>
      </Helmet>
      <Cell span={1} className='hero'>
        <div className='container box padded spaced'>
          <div className='projects-hero'>
            <div>
              <h1><Emo name='file_folder' /> <span>PROJECTS</span></h1>
              <div>
                <a className='action-btn' href='https://github.com/gnsp'><Icon b name='github' /> <span>GITHUB</span></a>
                <a className='action-btn' href='https://npmjs.com/~gnsp'><Icon b name='js-square' /> <span>NPM</span></a>
              </div>
            </div>
            <img src={proj} alt='' />
          </div>
        </div>
      </Cell>
      <Cell span={2} mob={1} className='container'>
        <Cell span={1} className='spaced left-col'>
          <Project
            name='Ironscript'
            href='https://ironscript.github.io/'
            tech={['language design', 'interpreter', 'javascript']}
            year='2016'
            desc={
              <>
                <p>
                  Ironscript is an asynchronous, functional (LISP like), modular programming language
                  interoperable with Javascript. I started working on it in November, 2016. Recently
                  I pushed the first Beta Version (v1.2.2) to npm. This new programming language uses an
                  asynchronous S-Expressions evaluator over Javascript functions and as I continue testing
                  the capabilities of Ironscript and its programming model, I find that it's better suited
                  for Rapid Application Prototyping / Development. Currently I am actively working on Ironscript
                  and looking for reviewers and contributors.
                </p>
                <h4>My role</h4>
                <p>
                  As of September 2019, I am the only contributor to Ironscript. Yeah, I created this programming
                  language, wrote an interpreter, module system, bundler and JS API for it, then implemented a
                  simple VirtualDOM using Ironscript and the language is proving to be worth the effort, though
                  there is a lot of room for improvement. But it does make writing UI much easier.
                </p>
              </>
            }
          />
        </Cell>
        <Cell span={1} className='spaced right-col'>
          <Project
            name='classd'
            href='https://npmjs.com/package/classd'
            tech={['javascript', 'react']}
            year='2018'
            desc={
              <>
                <p>
                  Classd is a fast, minimal JavaScript(ES6) utility for composing class names. It builds on ideas
                  and philosophy similar to that of JedWatson's classnames. classd defaults to the idea of using ES6
                  template literals for composing class names. It also provides functions similar to classNames and
                  classNames/dedupe for compatibility.
                </p>
                <h4>My Role</h4>
                <p>
                  I had started using ES6 Template Literals for composing class names in react, as early as 2016.
                  Eventually I figured that using template literals for this purpose could be made better, safer and
                  more performant. It all started with exploring ways of replicating Jedwatson's classNames functionalities
                  using template literals back in October 2017. I wrote a blogpost and a minial implematation of the
                  package at that time. Over the next years, I used that implementation in a number of projects in
                  production and optimized it for performance, to the point that it became faster than the original
                  classNames package. Recently in 2019 I opensourced it and published it on npm.
                </p>
              </>
            }
          />
        </Cell>
        <Cell span={1} className='spaced left-col'>
          <Project
            name='grille'
            href='https://github.com/gnsp/grille'
            tech={['javascript', 'react', 'css', 'less']}
            year='2017'
            desc={
              <>
                <p>
                  Grille is a flexbox based grid layout system. What makes it unique from mainstream grid implementations
                  is that, rather than following the row-column pattern, it organizes the layout as cells that can be
                  subdivided into any number of cells. The grille package provides a LESS/CSS file which can be used
                  as is. It also comes with a React component called Cell that abstracts away the complex bits of
                  composing the cell classes into a very simple api.
                </p>
                <h4>My Role</h4>
                <p>
                  I wrote the first implementation of this layout system in late 2016, but it remained unused for about a
                  year. But then in late 2017, I redesigned and reimplemented it as a part of the zomato UI library.
                  Then again in 2018, I simplified the API and rewrote the component, but this time as a standalone
                  project for use outside the zomato codebase with an MIT license.
                </p>
              </>
            }
          />
        </Cell>
        <Cell span={1} className='spaced right-col'>
          <Project
            name='ER Markup'
            href='https://github.com/GnsP/ER-MarkUp'
            tech={['language design', 'compiler', 'graphviz', 'c++']}
            year='2015'
            desc={
              <>
                <p>
                  ER Markup language is a textual framework to represent Entities and Relationships. This project started
                  as a weekend project in January 2015, to do a class assignment in a more productive way *wink*. I had no
                  wish to switch from Linux to Windows again just for a piece software that would enable me to to do one thing
                  in particular - 'Drawing ER Diagrams', that too one single class assignment. So I decided on designing and
                  developing something lighter and more productive for this specific task (After all the subject was
                  Software Analysis and Design) and started writing Grammar Productions for the same. After about one and half
                  days of work, I was sitting on some 500 lines of C++ which compiled my ER Diagram Descriptions written in the
                  ER Markup to Graphviz dot. Then it was an easy job to run a graphviz engine and get the actual images.
                </p>
                <h4>My role</h4>
                <p>
                  Meh ! Just call me a nerd for spending the first weekend of 2015 in hacking up this small compiler.
                  I have bigger plans for it though, but I am happy with existing ORM/ODMs. I may extend it when the
                  need arises.
                </p>
              </>
            }
          />
        </Cell>
        <Cell span={1} className='spaced left-col'>
          <Project
            name='Ghournal'
            href='https://www.npmjs.com/package/ghournal'
            tech={['javascript', 'pug']}
            year='2016'
            desc={
              <>
                <p>
                  Ghournal is a command-line based blog engine for hosting blogs on github-pages. It has a handful simple,
                  minimal and extendable features aimed at productivity. Currently it's stable and installable through npm
                  and is licensed MIT. The functionalities include:
                  1. It generates static HTML pages without any styling,
                  2. It organizes your blogposts as JSON files stored in a REST API like directory structure
                  3. It provides a CLI for writing, importing and publishing blogs.
                </p>
                <h4>My role</h4>
                <p>
                  I developed ghournal back in April-May, 2016 as me and a few of my friends wanted to have minimal and
                  light weight blogging option. Currently I am not actively contributing to ghournal but it has acquired
                  a small userbase and I am open to Issues and pull requests.
                </p>
              </>
            }
          />
        </Cell>
        <Cell span={1} className='spaced right-col'>
          <Project
            name='Metaliscpp'
            href='https://github.com/GnsP/GNS--META_LISCPP'
            tech={['c++', 'template metaprogramming', 'lisp']}
            year='2014'
            desc={
              <>
                <p>
                  Metaliscpp is an open source C++ library to make template meta programming in C++ easier and more readable.
                  It packs a Turing Complete set of template metaprogramming constructs and provides macros to mimic a
                  LISP like syntax for using those constructs. Currently it's deprecated and I recommend using Boost::hana
                  for the same purpose.
                </p>
                <h4>My role</h4>
                <p>
                  I wrote it back in March 2014 when new TMP libraries were kind of a hype thanks to the new C++11/14.
                  But somehow I decided to learn the thing the old way, so I did Metaliscpp in C++03 and it just remained
                  at that, a good project for learning. In the same year (2014), a few months later, Boost::hana was
                  introduced, which solved the same problems in a modern way.
                </p>
              </>
            }
          />
        </Cell>
        <Cell span={1} className='spaced left-col'>
          <Project
            name='Codex'
            href='https://github.com/GnsP/CODEX'
            tech={['python', 'cgi', 'mysql', 'html', 'css']}
            year='2014'
            desc={
              <>
                <p>
                  CODEX is a online coding contest management system modelled after Google Code Jam developed for
                  the Database Management Systems Lab, back in spring 2014, by a team of 3 students; me, Aditya Das
                  and Basir Khan. The webapp is written as a set of Python CGI modules.
                </p>
                <h4>My role</h4>
                <p>
                  I wrote the backend logic using Python3 CGI, this was my first web application development project.
                </p>
              </>
            }
          />
        </Cell>
        <Cell span={1} className='spaced right-col'>
          <Project
            name='Open Beowulf Cluster'
            href='https://github.com/GnsP/'
            tech={['c++', 'mpich2', 'linux']}
            year='2015'
            desc={
              <>
                <p>
                  An attempt to setup a Computing Cluster with a simple usage API. We went as far as setting up
                  the cluster with 4 Laptops connected over the LAN and writing a C++ wrapper over mpich2 that
                  handled the cluster configuration and did some basic load balancing. This project was undertaken
                  for the requirements of Product Development Lab - I and II during the Academic Year 2014-2015 by a
                  team of 3 students; me, Aditya Das and Rasesh Rout.
                </p>
                <h4>My role</h4>
                <p>
                  I was the guy writing the wrapper over mpich2 and hosting the master node.
                </p>
              </>
            }
          />
        </Cell>
      </Cell>

      <Cell span={1} className='container box padded spaced'>
        <div className='projects-hero'>
          <h1><Emo name='smiley' /> <span>FUN STUFF</span></h1>
        </div>
      </Cell>

      <Cell span={2} mob={1} className='container'>
        <Cell span={1} className='spaced left-col'>
          <Project
            name='404 : Road Not Found'
            href='https://gnsp.in/404-road-not-found'
            tech={['javascript', 'canvas API', 'WebAudio API']}
            year='2020'
            desc={
              <p>
                A small game written using JS, canvas API and WebAudio API as my entry for js13k-games 2020.
              </p>
            }
          />
        </Cell>
        <Cell span={1} className='spaced right-col'>
          <Project
            name='COVID-19 Tracker'
            href='https://gnsp.in/covid19'
            tech={['javascript', 'react', 'less']}
            year='2020'
            desc={
              <p>
                A COVID-19 tracker with prediction to analyse the spread of COVID-19 in India.
              </p>
            }
          />
        </Cell>
        <Cell span={1} className='spaced left-col'>
          <Project
            name='Odia Keyboard Driver'
            href='https://github.com/gnsp/odia-keyboard'
            tech={['javascript', 'es6']}
            year='2020'
            desc={
              <p>
                A phonetic keyboard input driver for Odia written in JS.
              </p>
            }
          />
        </Cell>
        <Cell span={1} className='spaced right-col'>
          <Project
            name='Web File Manager'
            href='https://gnsp.in/web-file-manager'
            tech={['javascript', 'react', 'less']}
            year='2019'
            desc={
              <p>
                An UI demo of a web based file manager written in <strong>React</strong> and <strong>Redux</strong>.
              </p>
            }
          />
        </Cell>
        <Cell span={1} className='spaced left-col'>
          <Project
            name='15 Puzzle'
            href='https://codepen.io/gnsp/pen/YzKvWPj'
            tech={['javascript', 'react', 'less']}
            year='2019'
            desc={<p>A 15 Puzzle game (rearrange 15 square tiles to form a picture) made using React Hooks.</p>}
          />
        </Cell>
        <Cell span={1} className='spaced right-col'>
          <Project
            name='Neon Clock'
            href='https://codepen.io/gnsp/pen/YzKvWPj'
            tech={['javascript', 'react', 'less']}
            year='2019'
            desc={<p>An animated, glowing and speaking timepiece made using React Hooks.</p>}
          />
        </Cell>
        <Cell span={1} className='spaced left-col'>
          <Project
            name='Thanos'
            href='https://gnsp.in/thanos'
            tech={['javascript', 'html5', 'canvas']}
            year='2019'
            desc={<p>Clone of an easter egg in the Google Search page for 'thanos', made in vanilla JS and canvas API.</p>}
          />
        </Cell>
        <Cell span={1} className='spaced right-col'>
          <Project
            name='Countries'
            href='https://gnsp.in/countries'
            tech={['python', 'pug', 'less']}
            year='2019'
            desc={
              <p>
                Listing of all countries in the world, with their flags, currency, area, population and
                population density. (Scrapped from publicly available sources)
              </p>
            }
          />
        </Cell>
        <Cell span={1} className='spaced left-col'>
          <Project
            name='Flag of India'
            href='https://codepen.io/gnsp/pen/oNveGGj'
            tech={['pug', 'less']}
            year='2019'
            desc={
              <p>
                Making the Indian flag using Pug and Less recursive mixins.
              </p>
            }
          />
        </Cell>
        <Cell span={1} className='spaced right-col'>
          <Project
            name='Typing Speed Visualizer'
            href='https://gnsp.in/Typing-Speed-Test'
            tech={['ironscript']}
            year='2016'
            desc={
              <p>
                Graphical and realtime typing speed visualizer made using Ironscript.
              </p>
            }
          />
        </Cell>
        <Cell span={1} className='spaced left-col'>
          <Project
            name='Tic tac toe'
            href='https://github.com/GnsP/gns-tic-tac-toe'
            tech={['c++', 'sdl']}
            year='2013'
            desc={
              <p>
                Tic tac toe developed using SDL1.2 and C/C++ with GUI and AI of 2 different levels (using min-max algorithm).
              </p>
            }
          />
        </Cell>
        <Cell span={1} className='spaced right-col'>
          <Project
            name='Othello'
            href='https://github.com/GnsP/gns-othello'
            tech={['c++', 'sdl']}
            year='2013'
            desc={
              <p>
                Othello or Reversi game using SDL1.2 and C/C++ with GUI and AI using min-max algorithm.
              </p>
            }
          />
        </Cell>
        <Cell span={1} className='spaced left-col'>
          <Project
            name='Odia Stories'
            href='https://gnsp.in/odia-stories'
            tech={['html', 'css']}
            year='2015'
            desc={
              <p>
                An initiative to create an online repository of some of my favorite short stories in Odia.
              </p>
            }
          />
        </Cell>
        <Cell span={1} className='spaced right-col'>
          <Project
            name='Sojourn'
            href='https://gnsp.in/assets/sojourn.pdf'
            tech={['LaTeX']}
            year='2016'
            desc={
              <p>
                Been writing poems since 2009, compiled 19 poems by myself into an eBook (sojourn.pdf), written under a pseudonym, of course.
              </p>
            }
          />
        </Cell>
      </Cell>
    </>
  );
}
